export enum PeriodTypeEnum {
  None = 'None',
  Hourly = 'Hourly',
  Daily = 'Daily',
  Monthly = 'Monthly'
}
